import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import type {
  ChartData,
  ChartOptions
} from 'chart.js'
import {
  Line,
} from 'react-chartjs-2'
import {
  color
} from '../../../styles'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

interface LineChartInterface {
  options: ChartOptions<'line'>,
  data: ChartData<'line'>
  showLegend: boolean,
  height: string | number,
  width: string | number
}

export const ChartLine: React.FC<LineChartInterface> = ({
  data,
  options,
  showLegend = true,
  ...props
}) => {
  const colorData = [
    color.colorPrimary,
    '#cd0055',
    color.colorDanger,
    '#e64b1d',
    '#ed6914',
    color.colorWarning,
    '#bc9e00',
    '#869806',
    color.colorSuccess,
    '#009a98',
    color.colorInfo,
    '#0073b9',
  ]

  return (
    <>
      <Line 
        {...props}
        data={{
          labels: data.labels,
          datasets: data.datasets.map((val, i) => ({
            ...val,
            backgroundColor: val?.backgroundColor ? val.backgroundColor : i > 12 ? colorData[Math.round(colorData.length / i)] : [colorData[i]],
            borderWidth: val.borderWidth ? val.borderWidth : 1
          }))
        }}
        options={{
          ...options,
          backgroundColor: options?.backgroundColor ? options.backgroundColor : color.colorPrimary,
          plugins: {
            ...options?.plugins,
            legend: {
              ...options?.plugins?.legend,
              display: showLegend,
            }
          }
        }}
      />
    </>
  )
}
